import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ClienteExpressService {
  baseUrl = environment.URL_API;

  constructor(
    private http: HttpClient
  ) { }


  getSegmentos() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      }),
    };
    return this.http
      .get<any>(
        this.baseUrl + "api/formulario/obtenersegmentos", 
        httpOptions
      )
      .toPromise();
  }

  getTipoEstanque() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      }),
    };
    return this.http
      .get<any>(
        this.baseUrl + "api/formulario/obtenertiposestanques", 
        httpOptions
      )
      .toPromise();
  }

  getVentanaHoraria() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      }),
    };
    return this.http
      .get<any>(
        this.baseUrl + "api/formulario/obtenerventanashorarias", 
        httpOptions
      )
      .toPromise();
  }

  getComunas() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      }),
    };
    return this.http
      .get<any>(
        this.baseUrl + "api/formulario/obtenercomunasconservicio", 
        httpOptions
      )
      .toPromise();
  }

  saveForm(formData) {
    return this.http.post<any>(this.baseUrl + 'api/formulario/enviarformularioexpresretail', formData).toPromise();

  }

}
